(function ($) {
  $.extend({
    log: function () {
      if (arguments.length > 0) {
        // join for graceful degregation
        var args = arguments.length > 1 ? Array.prototype.join.call(arguments, " ") : arguments[0];

        if (typeof window.ga === "function") {
          window.ga("send", "event", "Client Error", args);
        }

        // Browsers without a console simply skip logging
        try {
          console.log(args);
          return true;
        } catch {
          return false;
        }
      }
    },
  });
})(jQuery);
